import axios from "axios";

export const state = {
    loandisbursements: [],
};

export const getters = {
    loandisbursements: state => state.loandisbursements,
};

export const mutations = {
    setLoanDisbursements(state, newValue) {
        state.loandisbursements = newValue
    },
};

export const actions = {
    async fetchLoanDisbursements({ commit }) {
        await axios.get('/approvedloans').then(res => {
            commit('setLoanDisbursements', res.data.loandisbursements)
        })
    },
    async filterLoanDisbursements({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterapprovedloans";
        await axios.post(url, formData).then((response) => {
            commit('setLoanDisbursements', response.data.loandisbursements)
        })
    },
};
